/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * RA send MH request payload
 * @export
 * @interface RaSendMhRequest
 */
export interface RaSendMhRequest {
    /**
     * 
     * @type {number}
     * @memberof RaSendMhRequest
     */
    invoiceId?: number;
}

/**
 * Check if a given object implements the RaSendMhRequest interface.
 */
export function instanceOfRaSendMhRequest(value: object): value is RaSendMhRequest {
    return true;
}

export function RaSendMhRequestFromJSON(json: any): RaSendMhRequest {
    return RaSendMhRequestFromJSONTyped(json, false);
}

export function RaSendMhRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RaSendMhRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
    };
}

export function RaSendMhRequestToJSON(json: any): RaSendMhRequest {
    return RaSendMhRequestToJSONTyped(json, false);
}

export function RaSendMhRequestToJSONTyped(value?: RaSendMhRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceId': value['invoiceId'],
    };
}

